// @ts-nocheck
import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "inherit",
            size: "inherit",
        },
        css: css`
            ${siteWidthStyles()}
            padding-top: ${pxToRem(16)};
            flex-wrap: wrap;

            ${x =>
                breakpointValues(
                    [x.theme.design.typography.size.smallest, x.theme.design.typography.size.smaller, null, null, null],
                    "font-size",
                )}

            ${Slash} {
                margin: 0 ${pxToRem(8)};
            }

            a {
                /* Store Custom Code - Start */
                ${linkStyles("text.accent", "text.linkAltHover", false, true)}
                font-weight: ${x => x.theme.design.typography.weight.medium};
                /* Store Custom Code - End */
            }

            [aria-current="page"] {
                color: ${getColor("text.main")};
                font-weight: ${x => x.theme.design.typography.weight.medium}; /* Store Custom Code */
            }
        `,
    },
};

export default breadcrumbs;
